import { MimeTypeInfo } from "@rapid/types/media";

export const IMAGE_MIME_TYPE_TO_EXTENSION: Record<string, MimeTypeInfo> = {
    // Standard web image formats (browser-supported)
    "image/jpeg": {
        ext: ".jpeg",
        testFile:
            "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8A8A"
    },
    "image/jpg": {
        ext: ".jpg",
        testFile:
            "data:image/jpeg;base64,/9j/4AAQSkZJRgABAQEAYABgAAD/2wBDAAYEBQYFBAYGBQYHBwYIChAKCgkJChQODwwQFxQYGBcUFhYaHSUfGhsjHBYWICwgIyYnKSopGR8tMC0oMCUoKSj/2wBDAQcHBwoIChMKChMoGhYaKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCgoKCj/wAARCAABAAEDASIAAhEBAxEB/8QAFQABAQAAAAAAAAAAAAAAAAAAAAv/xAAUEAEAAAAAAAAAAAAAAAAAAAAA/8QAFQEBAQAAAAAAAAAAAAAAAAAAAAX/xAAUEQEAAAAAAAAAAAAAAAAAAAAA/9oADAMBAAIRAxEAPwA/8A8A"
    },
    "image/png": {
        ext: ".png",
        testFile:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
    },
    "image/webp": {
        ext: ".webp",
        testFile:
            "data:image/webp;base64,UklGRuABAABXRUJQVlA4INQBAABQFwCdASoAAQABPjEYiEQiIYh2kBABglpbuF2BkASk2q1vFOE+O+oDbIG6CaAdeEHADXxsFvmaHxjqkM98sPicjf9a+ZJOfqkM98r4erhpBx82SGe+WHxMz9LXbiCqmyejGgj9UhnjOSYCPj7mkbssPjYLQZtyBuxIESD42C3zND673KWHxsFvmaQ/VIZ75YfGwW+ZpD9Uhnvlh8bBb5mkP1SGe+WHxsFpGz3yw+Ngt8zSH6pDPfLD42C3zNIfqkM90AAA/v/Goh1XOXWRzEGb5vnU2PnK1OLMo7eBZLjbbD2n3TTUyd7MxZgBFbsU0j5E9M5uG+AsibRwjF9/QWY/rLXcx2lWxS+137KCQ81DOzzhrKR+QQEvw9gA8lGY/H1XcCrGp+r4+Q97xPHdbqpwH6qHWiQAUdL8D4Sw5XNODGDXhUPv1pPs2GHApJ1DlTJT5/fGmI5Oh6mxDtaPzUI1FRhmOQEibu/SiBq6iJ457XIz73N/Sos0wTGp0+UfNIiJCBnWH6Dhje00fdBIa3hLQlkeeD81/+UWBWreeSrGU8uuRkyvQag6apfEc9uWM62DlQRP/cyd0LrL78wOGGxsAAAAA2j9uGC8hTtbkXE2AAAAAAA="
    },
    "image/gif": {
        ext: ".gif",
        testFile: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7"
    },
    "image/svg+xml": {
        ext: ".svg",
        testFile:
            "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMSIgaGVpZ2h0PSIxIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxyZWN0IHdpZHRoPSIxIiBoZWlnaHQ9IjEiIGZpbGw9InJlZCIvPjwvc3ZnPg=="
    },
    "image/bmp": {
        ext: ".bmp",
        testFile:
            "data:image/bmp;base64,Qk1GAAAAAAAAADYAAAAoAAAAAQAAAAEAAAABAAEAAAAAAAAAAADEDgAAxA4AAAAAAAAAAAAAAAAAAP///wAA"
    },
    "image/x-icon": {
        ext: ".ico",
        testFile:
            "data:image/x-icon;base64,AAABAAEAAQEAAAEAIAAoAgAAFgAAACgAAAABAAAAAgAAAAEAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=="
    },
    "image/vnd.microsoft.icon": {
        ext: ".ico",
        testFile:
            "data:image/vnd.microsoft.icon;base64,AAABAAEAAQEAAAEAIAAoAgAAFgAAACgAAAABAAAAAgAAAAEAIAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA=="
    },

    // iPhone/iOS formats
    "image/heic": {
        ext: ".heic",
        testFile:
            "data:image/heic;base64,AAAAGGZ0eXBoZWljAAAAAG1pZjFoZWljAAABkW1ldGEAAAAAAAAACGhkbHIAAAAAAAAAAHBpY3QAAAAAAAAAAAAAAAAAAAAOcGl0bQAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAEAAAAaaW5mZQIAAAAAAQAAaGV2YwAAAAHY"
    },
    "image/heif": {
        ext: ".heif",
        testFile:
            "data:image/heif;base64,AAAAGGZ0eXBoZWlmAAAAAG1pZjFoZWljAAABkW1ldGEAAAAAAAAACGhkbHIAAAAAAAAAAHBpY3QAAAAAAAAAAAAAAAAAAAAOcGl0bQAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAEAAAAaaW5mZQIAAAAAAQAAaGV2YwAAAAHY"
    },
    "image/heic-sequence": {
        ext: ".heic",
        testFile:
            "data:image/heic;base64,AAAAGGZ0eXBoZWljAAAAAG1pZjFoZWljAAABkW1ldGEAAAAAAAAACGhkbHIAAAAAAAAAAHBpY3QAAAAAAAAAAAAAAAAAAAAOcGl0bQAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAEAAAAaaW5mZQIAAAAAAQAAaGV2YwAAAAHY"
    },
    "image/heif-sequence": {
        ext: ".heif",
        testFile:
            "data:image/heif;base64,AAAAGGZ0eXBoZWlmAAAAAG1pZjFoZWljAAABkW1ldGEAAAAAAAAACGhkbHIAAAAAAAAAAHBpY3QAAAAAAAAAAAAAAAAAAAAOcGl0bQAAAAEAAAAeaWxvYwAAAABEAAABAAEAAAABAAABGgAAAB0AAAAoaWluZgAAAAEAAAAaaW5mZQIAAAAAAQAAaGV2YwAAAAHY"
    },
    "image/x-apple-ios-png": {
        ext: ".png",
        testFile:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
    },

    // Android formats
    "image/x-android-drm-fl": {
        ext: ".fl",
        testFile:
            "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAADUlEQVR42mNkYPhfDwAChwGA60e6kgAAAABJRU5ErkJggg=="
    }
};

export const VIDEO_MIME_TYPE_TO_EXTENSION: Record<string, MimeTypeInfo> = {
    // Standard web video formats
    "video/mp4": { ext: ".mp4" },
    "video/quicktime": { ext: ".mov" },
    "video/x-msvideo": { ext: ".avi" },
    "video/webm": { ext: ".webm" },
    // avi variants
    "video/x-avi": { ext: ".avi" },
    "video/vnd.avi": { ext: ".avi" },
    "video/msvideo": { ext: ".avi" },
    "video/x-ms-avi": { ext: ".avi" },

    // H.264/H.265 variants
    "video/h264": { ext: ".mp4" },
    "video/h265": { ext: ".mp4" },
    "video/hevc": { ext: ".mp4" },
    "video/x-h264": { ext: ".mp4" },

    // iPhone/iOS formats
    "video/3gpp": { ext: ".3gp" },
    "video/3gpp2": { ext: ".3g2" },
    "video/mp4v-es": { ext: ".mp4" },

    // Android formats
    "video/3gp": { ext: ".3gp" },
    "video/3g2": { ext: ".3g2" },

    // Other common formats
    "video/avi": { ext: ".avi" },
    "video/x-ms-wmv": { ext: ".wmv" },
    "video/x-ms-asf": { ext: ".asf" },
    "video/x-flv": { ext: ".flv" },
    "video/x-matroska": { ext: ".mkv" },
    "video/ogg": { ext: ".ogv" },
    "video/mp2t": { ext: ".ts" },
    "video/x-mts": { ext: ".mts" },
    "video/mts": { ext: ".mts" },

    // Additional proprietary formats
    "video/vnd.dlna.mpeg-tts": { ext: ".ts" },
    "video/mp1s": { ext: ".mp1" },
    "video/mp2p": { ext: ".mp2" },
    "video/x-m4v": { ext: ".m4v" },
    "video/vnd.objectvideo": { ext: ".mp4" },
    "video/divx": { ext: ".divx" },
    "video/x-dv": { ext: ".dv" },
    "video/vnd.rn-realvideo": { ext: ".rv" },
    "video/x-ms-vob": { ext: ".vob" }
};

export const MEDIA_MIME_TYPES_TO_EXTENSION = {
    ...IMAGE_MIME_TYPE_TO_EXTENSION,
    ...VIDEO_MIME_TYPE_TO_EXTENSION
};

/**
 * @deprecated Use useFps() hook instead to get dynamic FPS from Firestore
 * This constant is kept for backward compatibility only
 */
export const FPS_RATE = 30;
export const MAX_VIDEO_DURATION = 10;
// due to fast ffmpeg stream copy when trimming file can be slightly longer than requested, we allow leeway
export const MAX_VIDEO_DURATION_FLEXIBILITY = 0.05;

// owlvit can be 960 for owlv2-base-patch16-ensemble or 1008 for owlv2-large-patch14-ensemble
// Issac and Peter confirmed we are using large
export const OWLVIT_SIZE = 1008;

export const SHOW_TEXT_PROMPT_SRC = true;

// Upload limits for deploy/share flows
export const MAX_IMAGES_PER_UPLOAD = 10;
export const MAX_VIDEOS_PER_UPLOAD = 1;
export const MAX_FILE_SIZE_BYTES = 100 * 1024 * 1024; // 100MB

export enum UploadLimitErrorType {
    TOO_MANY_IMAGES = "TOO_MANY_IMAGES",
    TOO_MANY_VIDEOS = "TOO_MANY_VIDEOS",
    MIXED_CONTENT = "MIXED_CONTENT",
    FILE_TOO_LARGE = "FILE_TOO_LARGE"
}
